const defaultUser = {
  user: {
    permissoes: {},
  },
};

const set = (infoUsuario) => {
  return localStorage.setItem('infoUsuarioDev', JSON.stringify(infoUsuario));
};

const get = (field) => {
  let infoUsuario = localStorage.getItem('infoUsuarioDev');

  try {
    infoUsuario = JSON.parse(infoUsuario);
    if (field) {
      return infoUsuario[field];
    }
    infoUsuario = infoUsuario || defaultUser;
    infoUsuario.permissoes = infoUsuario.permissoes || {};
    return infoUsuario;
  } catch (err) {
    return defaultUser;
  }
};

const remove = () => {
  return localStorage.removeItem('infoUsuarioDev');
};

const hasUser = (infoUsuario) => {
  if (!infoUsuario) {
    infoUsuario = get();
  }

  return (infoUsuario) && (infoUsuario.token);
};

const perm = (field) => {
  const infoUsuario = get();    
  return !!infoUsuario.user.permissoes[field];
};

export default {
  set,
  get,
  remove,
  hasUser,
  perm,
  defaultUser,
};
